'use client'

export const Campaign = () => {
  return (
    <section className="w-full py-8 lg:py-8 px-4 lg:px-[120px]" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-[800px] mx-auto">
        {/* 白い背景のコンテナ */}
        <div className="bg-white rounded-2xl px-4 lg:px-8 pt-0 pb-8 lg:py-8 relative">
          {/* PC版のみ: 先着100社様限定バッジ（外側左上） */}
          <div
            className="hidden lg:flex absolute items-center justify-center rounded-full w-[144px] h-[144px] -left-[22px] -top-[60px]"
            style={{
              backgroundColor: '#DA3B78',
              transform: 'rotate(-8.553deg)',
            }}
          >
            <div
              className="text-white text-center text-xl"
              style={{
                fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                fontWeight: 700,
                letterSpacing: '0.64px',
                lineHeight: '1.6',
              }}
            >
              <div>先着</div>
              <div>100社</div>
              <div>限定</div>
            </div>
          </div>

          {/* メインコンテンツエリア */}
          <div className="flex flex-col gap-4 lg:gap-8">
            {/* 上部：タイトルエリア */}
            <div className="flex flex-col gap-4 items-center justify-center relative">
              {/* 青いリボン */}
              <div className="relative w-full flex justify-center">
                <div className="relative w-full max-w-[420px] h-[40px] lg:h-[50px] flex items-center justify-center">
                  {/* リボン背景SVG */}
                  <img
                    src="/images/campaigns/ribbon-bg.svg"
                    alt=""
                    className="absolute inset-0 w-full h-full"
                    aria-hidden="true"
                  />
                  {/* テキスト */}
                  <div
                    className="relative z-10 text-white text-center px-4"
                    style={{
                      fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                      fontWeight: 700,
                      letterSpacing: '0.96px',
                      lineHeight: '1.6',
                    }}
                  >
                    <span className="text-lg lg:text-2xl">15,000円</span>
                    <span className="text-xs lg:text-base">（税込）</span>
                    <span className="text-lg lg:text-2xl">以上のご購入で</span>
                  </div>
                </div>
              </div>

              {/* メインテキスト */}
              <div
                className="text-center"
                style={{
                  color: '#009CD2',
                  fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                  fontWeight: 700,
                  lineHeight: '1.6',
                }}
              >
                {/* SP版 */}
                <div className="lg:hidden">
                  <div>
                    <span className="text-base" style={{ letterSpacing: '0.64px' }}>
                      当社おすすめ商品
                    </span>
                    <span className="text-xs" style={{ letterSpacing: '0.48px' }}>
                      を
                    </span>
                    <span className="text-base" style={{ letterSpacing: '0.64px' }}>
                      厳選
                    </span>
                    <span className="text-xs" style={{ letterSpacing: '0.48px' }}>
                      した
                    </span>
                  </div>
                  <div>
                    <span className="text-base" style={{ letterSpacing: '0.64px' }}>
                      お歳暮カタログ
                    </span>
                    <span className="text-xs" style={{ letterSpacing: '0.48px' }}>
                      を
                    </span>
                    <span className="text-base" style={{ letterSpacing: '0.64px' }}>
                      進呈いたします！
                    </span>
                  </div>
                </div>
                {/* PC版 */}
                <div className="hidden lg:block" style={{ letterSpacing: '0.96px' }}>
                  <span className="text-2xl">当社おすすめ商品</span>
                  <span className="text-lg">を</span>
                  <span className="text-2xl">厳選</span>
                  <span className="text-lg">した</span>
                  <span className="text-2xl">お歳暮カタログ</span>
                  <span className="text-lg">を</span>
                  <span className="text-2xl">進呈いたします！</span>
                </div>
              </div>

              {/* キャンペーン画像 */}
              <div className="w-full rounded-2xl overflow-hidden relative">
                <img
                  src="/images/campaigns/oseibo-campaign.png"
                  alt="お歳暮ギフトキャンペーン"
                  className="w-full h-auto object-cover"
                  style={{
                    aspectRatio: '4.2/3',
                    objectPosition: 'top',
                  }}
                />
              </div>

              {/* SP版のみ: 先着100社様限定バッジ（画像の左上に重ねる） */}
              <div
                className="lg:hidden absolute flex items-center justify-center rounded-full w-[106px] h-[106px]"
                style={{
                  backgroundColor: '#DA3B78',
                  transform: 'rotate(-8.553deg)',
                  left: '-3px',
                  top: '113px',
                }}
              >
                <div
                  className="text-white text-center text-base"
                  style={{
                    fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                    fontWeight: 700,
                    letterSpacing: '0.64px',
                    lineHeight: '1.6',
                  }}
                >
                  <div>先着</div>
                  <div>100社</div>
                  <div>限定</div>
                </div>
              </div>
            </div>

            {/* 下部：詳細情報エリア */}
            <div className="flex flex-col gap-2">
              {/* 対象期間 */}
              <div className="flex gap-2 items-center">
                <div
                  className="px-3 py-2 shrink-0 text-xs lg:text-base"
                  style={{
                    backgroundColor: '#009CD2',
                    color: '#FFFFFF',
                    // fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                    fontWeight: 700,
                    letterSpacing: '0.48px',
                    lineHeight: '1.6',
                  }}
                >
                  対象期間
                </div>
                <div
                  className="text-xs lg:text-base"
                  style={{
                    color: '#009CD2',
                    // fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                    fontWeight: 400,
                    letterSpacing: '0.48px',
                    lineHeight: '1.6',
                  }}
                >
                  2025年11月11日〜2025年12月20日
                </div>
              </div>

              {/* 注意事項 */}
              <div className="flex gap-2 items-start">
                <div
                  className="px-3 py-2 shrink-0 text-xs lg:text-base"
                  style={{
                    backgroundColor: '#009CD2',
                    color: '#FFFFFF',
                    // fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                    fontWeight: 700,
                    letterSpacing: '0.48px',
                    lineHeight: '1.6',
                  }}
                >
                  注意事項
                </div>
                <div
                  className="flex-1 text-xs lg:text-base"
                  style={{
                    color: '#009CD2',
                    // fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                    fontWeight: 400,
                    letterSpacing: '0.48px',
                    lineHeight: '1.6',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  <p style={{ marginBottom: 0 }}>
                    上記期間中に当サービスの会員登録を完了し、カタログのご購入依頼をいただいたアカウントが対象となります。
                  </p>
                  <p style={{ marginBottom: 0 }}>
                    当社からお渡しするお歳暮カタログは、ご購入手続き完了後にお渡しいたします。
                  </p>
                  <p style={{ marginBottom: 0 }}>
                    すでに当サービスでカタログを購入いただいたことがあるアカウントは対象外となります。
                  </p>
                  <p style={{ marginBottom: 0 }}>
                    同一法人であっても、部門が異なるなど別アカウントの場合は対象となります。
                  </p>
                  <p style={{ margin: 0 }}>本キャンペーンは先着100社に達し次第終了いたします。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
